<template>
  <div class="z-border-red" style="margin-bottom: 10px" v-if="order">
    <v-layout>
      <v-flex>
        <div class="ma-2">
          <v-checkbox
            :input-value="isCheck"
            :label="`Order No. ${order.id}`"
            style="display: inline-block; margin: 0"
            @change="assignCb(order.id)"
            color="primary"
          ></v-checkbox>
          <v-chip
            style="vertical-align: top"
            color="red"
            small
            disabled
            class="white--text"
            v-if="
              selectedBot.theme == 'nvbb' && status && status.label && status.value == 'ordered'
            "
            >{{ status.label }}</v-chip
          >
          <v-chip
            style="vertical-align: top"
            color="warning"
            small
            disabled
            class="white--text"
            v-if="
              selectedBot.theme == 'nvbb' &&
              isAdditionalPayment &&
              status &&
              ['ordered'].includes(status.value)
            "
            >มีสินค้าที่ต้องชำระเพิ่ม</v-chip
          >
        </div>
      </v-flex>
      <v-flex>
        <div class="ma-2 text-xs-right">
          <template v-if="order.app == 'facebook'">
            <em class="fab fa-facebook-square" style="color: #3c5a99" />
          </template>
          <template v-else-if="order.app == 'line'">
            <em class="fab fa-line" style="color: #00c300" />
          </template>
        </div>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-layout wrap fill-height>
      <v-flex xs12 sm7>
        <div style="border-right: 1px solid #eee; height: 100%">
          <template v-if="typeof orderDetailFormat == 'string'">
            <div class="pa-2">
              <nl2br tag="div" :text="order.productdetail"></nl2br>
            </div>
          </template>
          <template v-else-if="typeof orderDetailFormat == 'object'">
            <template v-for="(order, oindex) in orderDetailFormat">
              <template v-if="oindex < 3">
                <v-layout wrap :key="'order_' + oindex">
                  <v-flex sm1 xs2>
                    <div class="ma-2">
                      <v-img :src="order.photourl" aspect-ratio="1" alt class="grey lighten-2">
                        <template v-slot:placeholder>
                          <v-layout fill-height align-center justify-center ma-0>
                            <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                          </v-layout>
                        </template>
                      </v-img>
                    </div>
                  </v-flex>
                  <v-flex sm7 xs6 style="word-break: break-word">
                    <div class="ma-2">
                      {{ order.name }}
                      <template v-if="order.option">({{ order.option }})</template>
                    </div>
                  </v-flex>
                  <v-flex xs4 class="text-xs-right">
                    <div class="ma-2">x {{ order.quantity }}</div>
                  </v-flex>
                </v-layout>
                <v-divider v-if="oindex < orderDetailFormat.length - 1" :key="oindex"></v-divider>
              </template>
              <template v-if="oindex >= 3 && orderShowAll">
                <v-layout wrap :key="'order_' + oindex">
                  <v-flex sm1 xs2>
                    <div class="ma-2">
                      <v-img :src="order.photourl" aspect-ratio="1" alt class="grey lighten-2">
                        <template v-slot:placeholder>
                          <v-layout fill-height align-center justify-center ma-0>
                            <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                          </v-layout>
                        </template>
                      </v-img>
                    </div>
                  </v-flex>
                  <v-flex sm7 xs6 style="word-break: break-word">
                    <div class="ma-2">
                      {{ order.name }}
                      <template v-if="order.option">({{ order.option }})</template>
                    </div>
                  </v-flex>
                  <v-flex xs4 class="text-xs-right">
                    <div class="ma-2">x {{ order.quantity }}</div>
                  </v-flex>
                </v-layout>
                <v-divider v-if="oindex < orderDetailFormat.length - 1" :key="oindex"></v-divider>
              </template>
            </template>

            <div class="text-xs-center">
              <v-btn icon @click="orderShowAll = !orderShowAll"
                ><v-icon color="primary">{{
                  orderShowAll ? 'arrow_drop_up' : 'arrow_drop_down'
                }}</v-icon></v-btn
              >
            </div>

            <EditProductDetail
              v-model="orderDetailFormat"
              @saveProductDetail="saveProductDetail"
            ></EditProductDetail>
          </template>

          <div>
            <v-layout v-if="order.amount != null">
              <v-flex>
                <div class="pa-2">{{ $t('Total') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">{{ totalDrink }}</span>
                </div>
              </v-flex>
            </v-layout>
          </div>

          <div>
            <v-layout v-if="order.shippingcharge != null">
              <v-flex>
                <div class="pa-2">{{ $t('Shipping fee') }}:</div>
              </v-flex>
              <v-flex>
                <div class="pa-2 text-xs-right">
                  <span class="primary-color">
                    ฿ {{ lalamoveShipping(order) || order.shippingcharge | decimalFormat }}</span
                  >
                </div>
              </v-flex>
            </v-layout>
          </div>
          <v-divider />

          <div class="pa-2">
            <v-layout>
              <v-flex> จัดส่งโดย </v-flex>
              <v-flex class="text-xs-right">
                <multiselect
                  v-model="order.shippingtype"
                  :options="['hub', 'drop', 'scg', 'interexpress', 'admin_suggest']"
                  :allow-empty="false"
                  :searchable="false"
                  selectLabel
                  selectedLabel
                  deselect-label
                  @select="$emit('updateOrder', 'save')"
                >
                  <template slot="singleLabel" slot-scope="props">{{
                    props.option | getShipping
                  }}</template>
                  <template slot="option" slot-scope="props">
                    {{ props.option | getShipping }}
                  </template>
                </multiselect>
              </v-flex>
            </v-layout>
            <img
              v-if="shippingType == 'normal'"
              src="/static/img/assets/payment/normal_charge_logo.png"
              alt
              class="responsive-img"
              style="max-height: 50px"
            />
            <img
              v-else-if="shippingType == 'ems'"
              src="/static/img/assets/payment/ems_charge_logo.png"
              alt
              class="responsive-img"
              style="max-height: 50px"
            />
            <img
              v-else-if="shippingType == 'kerry'"
              src="/static/img/assets/payment/kerry_charge_logo.png"
              alt
              class="responsive-img"
              style="max-height: 50px"
            />
            <template v-else>
              <template v-if="shippingType">
                <img
                  @error="onImageLoadFailure($event)"
                  :src="'/static/img/assets/payment/' + shippingType + '_logo.png'"
                  alt
                  class="responsive-img"
                  style="max-height: 50px"
                />

                <div v-if="shippingType == 'cod_charge'" class="caption">
                  {{ $t('cod_charge') }}
                </div>
                <div v-else>
                  <v-chip>{{ shippingType }}</v-chip>
                </div>
              </template>
            </template>
          </div>
          <div class="ml-2">
            <template v-if="shippingType && shippingType.includes('other')">{{
              shippingValue
            }}</template>
            <template v-else>{{ $t(shippingType) }}</template>
          </div>
          <v-divider />
          <v-layout v-if="selectedBot.theme == 'nvbb'">
            <v-flex class="pa-2">
              <div class="pa-2 mb-1 z-border-red">
                <v-layout>
                  <v-flex class="primary--text"> จาก </v-flex>
                  <v-flex shrink>
                    <v-btn
                      v-if="order.shippingtype === 'drop'"
                      color="primary"
                      small
                      depressed
                      @click="toggleDroppointClick(order)"
                    >
                      แก้ไข
                    </v-btn>
                    <v-btn
                      v-if="order.shippingtype === 'hub'"
                      color="primary"
                      small
                      depressed
                      @click="
                        toggleHub = true
                        dataEdit = order
                      "
                    >
                      แก้ไข
                    </v-btn>
                  </v-flex>
                </v-layout>
                <div class="pa-2">
                  <template>
                    {{ order.remark }}
                  </template>
                </div>
              </div>

              <div class="pa-2 mb-1 z-border-red">
                <v-layout>
                  <v-flex>
                    <span class="primary--text"> ถึง </span>
                    <editable
                      v-model="nameEdit"
                      :filter="'text'"
                      :type="'textarea'"
                      @edited="editName"
                    ></editable>
                  </v-flex>
                  <v-flex shrink>
                    <small
                      v-if="
                        !(
                          order_json &&
                          order_json.stops &&
                          order_json.stops.length > 0 &&
                          order_json.stops[0].location.lat &&
                          order_json.stops[1].location.lat
                        )
                      "
                      style="color: red"
                    >
                      <!-- กรุณาเลือกตำแหน่งที่อยู่ซ้ำอีกครั้ง -->
                    </small>
                    <v-btn
                      :disabled="
                        !(
                          order_json &&
                          order_json.stops &&
                          order_json.stops.length > 0 &&
                          order_json.stops[0].location.lat
                        ) &&
                        !(
                          order_json &&
                          order_json.data &&
                          order_json.data.stops &&
                          order_json.data.stops.length > 0 &&
                          order_json.data.stops[0].coordinates.lat
                        )
                      "
                      color="primary"
                      small
                      depressed
                      @click="editAddress(order)"
                    >
                      แก้ไข
                    </v-btn>
                  </v-flex>
                </v-layout>

                <div class="pa-2">
                  <template>
                    {{ order.nameaddress }}
                  </template>
                </div>
              </div>
            </v-flex>
          </v-layout>
          <v-divider v-if="selectedBot.theme == 'nvbb'" />
          <v-layout>
            <v-flex class="pa-2">
              <div class="caption">
                <template v-if="$store.state.centralPage.includes(selectedBot.pageid)"
                  >หมายเลขเดอะวัน</template
                >
                <template v-else>{{ $t('Remark') }}</template>
              </div>
              <editable
                v-model="order.remark"
                :filter="'text'"
                :type="'textarea'"
                @edited="$emit('updateOrder', 'save')"
              ></editable>
            </v-flex>
          </v-layout>

          <v-layout v-if="order.shippingtype === 'drop' && selectedBot.theme == 'nvbb'">
            <v-flex class="pa-2">
              <div class="caption">
                <template v-if="$store.state.centralPage.includes(selectedBot.pageid)"
                  >หมายเลขเดอะวัน</template
                >
                <template v-else>{{ $t('Remark') }}ถึงคนขับ</template>
              </div>
              <multiselect
                class="mb-2"
                v-model="driverRemark"
                :options="remarkToDriver"
                label="label"
                :allow-empty="false"
                :searchable="false"
                selectLabel
                selectedLabel
                deselect-label
                track-by="label"
                @select="onSelectRemarkToDriver"
              ></multiselect>
              <editable
                v-if="driverRemark && driverRemark.label === 'Other'"
                v-model="driverRemark.value"
                :filter="'text'"
                :type="'textarea'"
                @edited="editRemarks"
              ></editable>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex xs12 sm5>
        <div style="word-break: break-word" class="pa-2">
          <a target="_BLANK" :href="`https://business.facebook.com${order.inboxurl}`"
            >{{ order.first_name }} {{ order.last_name }}</a
          >

          <template
            v-if="
              selectedBot.pageid == '103012211224246' ||
              selectedBot.pageid == '635426456938760' ||
              selectedBot.pageid == '613259679129221' ||
              selectedBot.pageid == '101857778024677'
            "
          >
            <template v-if="typeof shippingAddressPosition == 'string'">
              <editable
                v-if="order.nameaddress"
                v-model="order.nameaddress"
                :type="'textarea'"
                :hasCopy="true"
                @edited="$emit('updateOrder', 'save')"
              ></editable>
            </template>
            <template v-else>
              <a
                :href="`https://maps.google.com?q=${shippingAddressPosition.lat},${shippingAddressPosition.lng}`"
                target="_blank"
                style="word-break: break-word"
              >
                https://maps.google.com?q={{
                  `${shippingAddressPosition.lat},${shippingAddressPosition.lng}`
                }}
              </a>
            </template>
          </template>
          <template v-else>
            <editable
              v-if="order.nameaddress"
              v-model="order.nameaddress"
              :type="'textarea'"
              @edited="editNameaddress"
              :hasCopy="true"
            ></editable>
          </template>
          <div class="caption mt-3">{{ $t('Status') }}</div>
          <div class="primary--text">{{ order.userstatus ? order.userstatus : '-' }}</div>
          <template v-if="$store.state.centralPage.includes(selectedBot.pageid)">
            <div class="caption mt-3">{{ $t('Live name') }}</div>
            <div class="primary--text">{{ order.livename ? order.livename : '-' }}</div>
          </template>
          <div class="caption mt-3">{{ $t('Tag') }}</div>
          <template v-if="tags.length > 0">
            <v-chip
              small
              v-for="(tag, index) in tags"
              :key="'tag_' + index"
              outline
              color="primary"
              disabled
              >{{ tag }}</v-chip
            >
          </template>
          <template v-else>
            <div class="primary--text">-</div>
          </template>
        </div>

        <div class="form-control px-2">
          <div class="caption mt-3">{{ $t('วันที่จัดส่ง') }}</div>
          <DatepickerCustomDialog
            :key="order.id"
            v-model="shippingdate"
            @input="changeShippingDate($event, true)"
          >
            <template v-slot="{ computedDate }">
              <input
                name="appointment_date"
                data-vv-as="วันที่นัดหมาย"
                :value="computedDate"
                readonly
                placeholder="DD/MM/YYYY"
                type="text"
              />
            </template>
          </DatepickerCustomDialog>
        </div>
        <v-divider></v-divider>

        <div class="pa-2">
          <multiselect
            class="mb-2"
            v-model="status"
            :options="orderStatusOptions"
            label="label"
            :allow-empty="false"
            :searchable="false"
            selectLabel
            selectedLabel
            deselect-label
            track-by="label"
            @select="onSelectOrderStatus"
          ></multiselect>

          <div v-if="order.shippingtype === 'drop' && selectedBot.theme == 'nvbb'">
            <v-checkbox
              class="mt-1"
              color="primary"
              style="font-size: 14px; color: black"
              label="จัดส่งแบบเก็บเงินปลายทางโดย LALAMOVE"
              :input-value="
                order_json && order_json.specialRequests
                  ? order_json.specialRequests[0] === 'COD'
                  : ''
              "
              @change="onSelectOrderPay"
            ></v-checkbox>
            <!-- <multiselect
              v-model="statusPay"
              :options="orderPayOptions"
              label="label"
              :allow-empty="false"
              :searchable="false"
              selectLabel
              selectedLabel
              deselect-label
              track-by="label"
              @select="onSelectOrderPay"
            ></multiselect> -->
          </div>

          <template v-if="order.status == 'shipped'">
            <div class="form-control pt-2">
              <textarea
                type="text"
                v-model="order.trackingno"
                class="form-control"
                :placeholder="$t('Tracking')"
                maxlength="2000"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn
                outline
                color="primary"
                class="ma-0"
                @click="$emit('updateOrder', 'send')"
                :disabled="
                  order.trackingno == null ||
                  order.trackingno == '' ||
                  order.trackingno.trim() == ''
                "
              >
                <em class="far fa-share-square" />
                &nbsp;
                {{ $t('Send') }}
              </v-btn>
            </div>
          </template>
          <template v-else-if="order.status == 'canceled'">
            <div class="form-control pt-2">
              <input
                type="text"
                v-model="order.reason"
                class="form-control"
                :placeholder="$t('Reason')"
                maxlength="300"
              />
            </div>
            <div class="text-xs-center text-sm-right mb-3">
              <v-btn
                outline
                color="primary"
                class="ma-0"
                @click="$emit('updateOrder', 'save')"
                :disabled="order.reason == null || order.reason == '' || order.reason.trim() == ''"
              >
                <em class="far fa-save" />
                &nbsp;
                {{ $t('Save') }}
              </v-btn>
              <v-btn
                outline
                color="primary"
                class="ma-0"
                @click="$emit('updateOrder', 'send')"
                :disabled="order.reason == null || order.reason == '' || order.reason.trim() == ''"
              >
                <em class="far fa-share-square" />
                &nbsp;
                {{ $t('Send') }}
              </v-btn>
            </div>
          </template>
          <template v-else>{{ order.trackingno }}</template>
        </div>

        <v-layout>
          <v-flex>
            <div class="pa-2">
              <div>
                <template v-if="shippingType && shippingType == 'cod_charge'">
                  {{ $t('cod_charge') }}
                </template>
                <template v-else>
                  <template v-if="order.payment == 'banktransfer' || order.payment == 'transfer'">
                    {{ $t('Bank Transfer') }}
                  </template>
                  <template v-else-if="order.payment == 'cod'">{{ $t('cod_charge') }}</template>
                  <template v-else-if="order.payment == 'qrcode'">Qr Code</template>
                  <template v-else-if="order.payment == 'fbpay'">
                    {{ $t('Mobile Banking') }}
                  </template>
                  <template v-else-if="order.payment == 'credit'">{{ $t('Credit card') }}</template>
                  <template v-else>{{ $t(order.payment) }}</template>
                </template>
                <div class="caption" v-if="order.transactionid">{{ $t(order.transactionid) }}</div>
              </div>
              {{ order.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
            </div>
          </v-flex>
          <v-flex>
            <div class="pa-2">
              <div style="text-align: right">
                <print-all-covers
                  :orders="[order]"
                  :circle="true"
                  style="display: inline-block"
                  @onPrinCover="onPrinCover(false, $event)"
                  type="nvbbpreorder"
                ></print-all-covers>
                <PrintAllCoversCentral
                  v-if="$store.state.centralPage.includes(selectedBot.pageid)"
                  :orders="[order]"
                  :circle="true"
                  @onPrinCover="onPrinCover(true, $event)"
                  style="display: inline-block"
                ></PrintAllCoversCentral>
                <!-- <print-all-covers
                  v-else
                  :orders="[order]"
                  :circle="true"
                  @onPrinCover="onPrinCover(false, $event)"
                  style="display: inline-block"
                ></print-all-covers> -->
              </div>
            </div>
          </v-flex>
        </v-layout>

        <template v-if="isAdditionalPayment">
          <v-divider />
          <div class="error--text pa-2">
            <strong>มีสินค้าที่ต้องชำระเพิ่ม</strong>
            <template v-for="(count, index) in this.value.jsonvalue.additional_payment">
              <div :key="index">{{ index }} x{{ count }}</div>
            </template>
          </div>
        </template>
      </v-flex>
    </v-layout>
    <template>
      <div class="hr"></div>

      <a href="javascript:void(0);" @click="showDetail = !showDetail" style="text-decoration: none">
        <div class="text-xs-center" style="margin: 10px auto">
          {{ $t('Click to view slip') }}
          <i class="fas" :class="{ 'fa-chevron-down': showDetail, 'fa-chevron-up': !showDetail }" />
        </div>
      </a>
      <div
        v-show="showDetail"
        style="margin-bottom: 0; background: rgb(253, 253, 253); border-bottom-left-radius: 10px"
        class="mb-3"
      >
        <upload-file-button
          :value="image"
          :outputtype="'base64'"
          @onUploaded="onUploaded"
        ></upload-file-button>
        <template v-if="showDetail">
          <template v-if="order.note == 'base64'">
            <template v-if="!loading">
              <load-base64
                v-model="image"
                :orderid="order.id"
                :key="'slip_' + order.id + '_' + timestamp"
              ></load-base64>
            </template>
          </template>
          <template v-else-if="order.note">
            <editable
              v-model="order.note"
              :filter="'image'"
              :type="'image'"
              @edited="$emit('updateOrder', 'save')"
            ></editable>
          </template>
        </template>
      </div>
    </template>
    <v-dialog persistent v-model="toggleDroppoint" max-width="600">
      <v-card>
        <v-layout align-center row wrap>
          <v-flex class="ml-3">
            <h3 class="title">แก้ไขที่อยู่</h3>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn flat small fab @click="toggleDroppoint = false">
              <v-icon> close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-card-text>
          <v-autocomplete
            outline
            v-model="droppointSelect"
            :items="$store.state.nvbbDroppointLocationOptions"
            small
            filled
            :label="$t('Address')"
          ></v-autocomplete>
          <v-btn
            class="pl-0 ml-0"
            style="width: 100%"
            outline
            color="primary"
            @click="editAddressDroppoint"
          >
            ยืนยันการแก้ไข
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="toggleHub" max-width="600">
      <v-card>
        <v-layout align-center row wrap>
          <v-flex class="ml-3">
            <h3 class="title">แก้ไขที่อยู่</h3>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn flat small fab @click="toggleHub = false">
              <v-icon> close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-card-text>
          <v-autocomplete
            outline
            v-model="hubSelect"
            :items="nvbb.hubLocationOptions"
            small
            filled
            :label="$t('Address')"
          ></v-autocomplete>
          <v-btn
            class="pl-0 ml-0"
            style="width: 100%"
            outline
            color="primary"
            @click="editAddressHub(hubSelect)"
          >
            ยืนยันการแก้ไข
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <template v-if="order_json && (order_json.stops || order_json.data.stops)">
      <select-gmap
        v-if="showToAddress"
        v-model="showToAddress"
        :location="
          order_json.data && order_json.data.stops && order_json.data.stops.length > 0
            ? order_json.data.stops[1].coordinates
            : order_json.stops[1].location
        "
        @changeLocation="changeLocation($event)"
      ></select-gmap>
    </template>
  </div>
</template>

<script>
import mixin from './OrderSummaryItem.js'
import LoadBase64 from './LoadBase64'
import Editable from '@/components/elements/Editable'
import EditProductDetail from './EditProductDetail.vue'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import moment from 'moment'
import { calculateShippingPrice } from '@/nvbb.js'
import numeral from 'numeral'
import UploadFileButton from '@/components/elements/UploadFileButton'
export default {
  mixins: [mixin],
  components: {
    Editable,
    'load-base64': LoadBase64,
    EditProductDetail,
    DatepickerCustomDialog,
    UploadFileButton
  },
  data() {
    return {
      orderShowAll: false,
      image: null,
      timestamp: moment().format('x'),
      showDetail: false,
      shippingdate: null
    }
  },
  filters: {
    getShipping(type) {
      let shippingOptions = [
        {
          value: 'drop',
          name: 'Drop point'
        },
        {
          value: 'hub',
          name: 'Hub'
        },
        {
          value: 'scg',
          name: 'SCG'
        },
        {
          value: 'interexpress',
          name: 'Inter express'
        },
        {
          value: 'admin_suggest',
          name: 'Admin'
        }
      ]
      let val = shippingOptions.find((el) => el.value == type)
      return val ? val.name : el
    }
  },
  computed: {
    totalDrink() {
      if (typeof this.orderDetailFormat == 'object') {
        return this.orderDetailFormat
          .map((el) => {
            return parseInt(el.quantity)
          })
          .reduce((prev, cur) => {
            return prev + cur
          })
      } else {
        return 0
      }
    },
    isAdditionalPayment() {
      let found = false
      if (this.value && this.value.jsonvalue && this.value.jsonvalue.additional_payment) {
        for (const key in this.value.jsonvalue.additional_payment) {
          if (Object.hasOwnProperty.call(this.value.jsonvalue.additional_payment, key)) {
            const element = this.value.jsonvalue.additional_payment[key]
            if (element > 0) found = true
          }
        }
      }
      return found
    }
  },
  methods: {
    editNameaddress() {
      this.nameEdit =
        this.order.nameaddress && typeof this.order.nameaddress == 'string'
          ? this.order.nameaddress.split(' , ')[0]
          : ''
      this.$emit('updateOrder', 'save')
    },
    lalamoveShipping(order) {
      if (order.order_json) {
        let json = null
        try {
          json = JSON.parse(order.order_json)
        } catch (error) {}
        return (
          (json && json.totalFee ? parseInt(json.totalFee) : 0) +
          (json && json.shop_fee ? parseInt(json.shop_fee) : 0)
        )
      }
    },
    async onUploaded(file) {
      if (file) {
        this.$set(this.order, 'note', file)
        this.timestamp = moment().format('x')
        this.$emit('updateOrder', 'save')
      }
    },
    afterMounted() {
      if (this.order) {
        this.shippingdate = this.order.shippingdate
          ? moment(this.order.shippingdate).format('YYYY-MM-DD')
          : null
      }
    },
    changeShippingDate(date, ischange) {
      this.$set(this.order, 'shippingdate', date)
      this.$emit('input', this.order)
      this.$emit('onChangeStatus')
    },
    saveProductDetail(detail) {
      let total = detail
        .map((el) => {
          return parseInt(el.quantity)
        })
        .reduce((prev, curr) => prev + curr)
      let rate = 0
      try {
        rate = calculateShippingPrice({
          type: this.order.shippingtype,
          address: this.order.nameaddress,
          total: total
        })
      } catch (error) {
        rate = false
      }
      if (rate !== false) {
        this.$set(this.order, 'shippingcharge', numeral(rate).format('0.00'))
      } else {
      }
      this.$set(this.order, 'productdetail', JSON.stringify(detail))
      this.$emit('input', this.order)
      this.$emit('onChangeStatus')
    },
    saveSlip(id, file) {
      return new Promise((resolve, reject) => {
        api.saveSlip(
          { params: { id: id, pageid: this.selectedBot.pageid }, data: { note: file } },
          function (error, response) {
            if (error) {
              reject(error)
              return
            }

            resolve(response)
          }
        )
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/NvbbSummaryItem.vue